import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    ExternalApis,
    CreateExternalApisInput,
    UpdateExternalApisInput,
    DeleteExternalApisInput
} from '@app/core/services/api/API.service';

@Injectable({
    providedIn: 'root'
})
export class ExternalApiService {
    private amplifyClient = generateClient();

    constructor() {}

    async listExternalApis(limit: number = 50): Promise<ExternalApis[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listExternalApis,
                    variables: { limit }
                })
            ).data.listExternalApis.items;
            if (data) return data as ExternalApis[];
        } catch (error) {
            console.error('Error finding ExternalApis:', error);
            return null;
        }
    }

    async createExternalApi(
        input: CreateExternalApisInput
    ): Promise<ExternalApis> {
        try {
            const client = (
                await this.amplifyClient.graphql({
                    query: mutations.createExternalApis,
                    variables: {
                        input
                    }
                })
            ).data.createExternalApis;
            if (client) return client as ExternalApis;
        } catch (error) {
            console.error('Error creating api:', error);
            return null;
        }
    }

    async updateExternalApi(
        input: UpdateExternalApisInput
    ): Promise<ExternalApis> {
        try {
            const externalApi = (
                await this.amplifyClient.graphql({
                    query: mutations.updateExternalApis,
                    variables: {
                        input
                    }
                })
            ).data.updateExternalApis;
            if (externalApi) return externalApi as ExternalApis;
        } catch (error) {
            console.error('Error updating api:', error);
            return null;
        }
    }

    async deleteExternalApi(
        input: DeleteExternalApisInput
    ): Promise<ExternalApis> {
        try {
            const deleteExternalApi = (
                await this.amplifyClient.graphql({
                    query: mutations.deleteExternalApis,
                    variables: {
                        input
                    }
                })
            ).data.deleteExternalApis;

            return deleteExternalApi as ExternalApis;
        } catch {
            console.error('Error deleted ExternalApi:', Error);
            return null;
        }
    }
}
